import type { Typed } from 'services/api/fields/core';

import { GroupType, GroupTypeOptions } from './GroupType';

export type ClientGroupTypeConfig = {
  caseManager: boolean;
  launchDate?: string;
  projectedDischarge: {
    enabled: boolean;
  };
  referral: boolean;
  safeReturn: boolean;
  utilizationManager: boolean;
  utilizationManagement: {
    enabled: boolean;
    planTypeClassification: {
      id: string;
      name: string;
    }[];
    aiSummary: boolean;
  };
};

export interface ClientGroupTypeOptions {
  config: ClientGroupTypeConfig;
  groupType?: GroupTypeOptions;
  serviceType?: string;
  [key: string]: any;
}

function getDefaults(): ClientGroupTypeOptions {
  return {
    id: '',
    clientId: '',
    groupTypeId: '',
    config: {
      caseManager: false,
      projectedDischarge: {
        enabled: false,
      },
      referral: false,
      safeReturn: false,
      utilizationManagement: {
        enabled: false,
        planTypeClassification: [],
        aiSummary: false,
      },
      utilizationManager: false,
    },
    serviceType: undefined,
  };
}

let ClientGroupType: new <T extends ClientGroupTypeOptions>(options: T) => Typed<_ClientGroupType<T>, T>;

class _ClientGroupType<T extends ClientGroupTypeOptions = ClientGroupTypeOptions> {
  groupType!: GroupType | null;
  serviceType!: string | undefined;

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.groupType = opts.groupType ? new GroupType(opts.groupType) : null;
    this.serviceType = opts.serviceType;
  }

  get isManaged() {
    return this.serviceType === 'managed';
  }

  get isProvided() {
    return this.serviceType === 'provided';
  }
}

// eslint-disable-next-line prefer-const
ClientGroupType = _ClientGroupType as typeof ClientGroupType;

export default ClientGroupType;
export { ClientGroupType };
export type ClientGroupType<T extends ClientGroupTypeOptions = ClientGroupTypeOptions> = Typed<_ClientGroupType<T>, T>;
